// extracted by mini-css-extract-plugin
export default {"input":"input_input__g5nKz","disabled":"input_disabled__ZLIn8"};